<script setup>
import { computed } from 'vue';
import { frontendURL } from 'dashboard/helper/URLHelper';
import { formatRangeHeading } from 'dashboard/routes/dashboard/planning/events/eventsDateRange';

import CardLayout from 'dashboard/components-next/CardLayout.vue';

const props = defineProps({
  id: { type: [String, Number], default: '' },
  name: { type: String, default: '' },
  description: { type: String, default: '' },
  systemStage: { type: String, default: '' },
  customStatus: { type: String, default: '' },
  accountId: { type: [String, Number], default: 0 },
  startDate: { type: String, default: '' },
  endDate: { type: String, default: '' },
});

const navigateTo = computed(() =>
  frontendURL(`accounts/${props.accountId}/planning/events/${props.id}`)
);

const eventDateLabel = computed(() => {
  if (!props.startDate) return '';
  return formatRangeHeading(props.startDate, props.endDate || props.startDate);
});
</script>

<template>
  <router-link :to="navigateTo">
    <CardLayout
      layout="col"
      class="[&>div]:justify-start [&>div]:gap-2 [&>div]:px-4 [&>div]:pt-4 [&>div]:pb-5 [&>div]:items-start hover:bg-n-slate-2 dark:hover:bg-n-solid-3"
    >
      <div class="min-w-0 flex-1 flex flex-col items-start gap-2 w-full">
        <div class="flex items-center min-w-0 justify-between gap-2 w-full">
          <h5
            class="text-sm font-medium leading-4 truncate min-w-0 text-n-slate-12"
          >
            {{ name }}
          </h5>
          <span
            class="text-xs inline-flex items-center font-medium rounded-md whitespace-nowrap capitalize bg-n-alpha-2 px-1.5 h-6 text-n-slate-12 flex-shrink-0"
          >
            {{ customStatus || systemStage }}
          </span>
        </div>
        <p
          v-if="description"
          class="text-sm text-n-slate-11 line-clamp-2 w-full"
        >
          {{ description }}
        </p>
        <span v-if="eventDateLabel" class="text-xs text-n-slate-9">
          {{ eventDateLabel }}
        </span>
      </div>
    </CardLayout>
  </router-link>
</template>
